import { useContext } from "react";
import { ModalContext } from "context/ModalContext";
import { Button } from "antd";
import AddBenefit from "components/widgets/modals/AddBenefit";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { fetch_product_benefits } from "services/apiSrv";
import { useQuery } from "react-query";


function Benefits(props) {
  const { setModalShow, modalShow, modalClose } = useContext(ModalContext);

        const {
          data: benefits,
          isLoading,
          isError,
          error,
          refetch,
      } = useQuery({
          queryKey: ['benefits'],
          queryFn: fetch_product_benefits,
          // Optional: Configure retry, stale time, etc.
          retry: 2,
          staleTime: 5 * 60 * 1000, // 5 minutes
      });
  
      console.log("POOIII====", benefits)

   const history = useHistory();

   

    // Handle edit action
  const handleEdit = (id) => {
    // history.push(`${routes.editProduct}/${id}`);
   history.push(`/dashboard/setup/benefit/${id}`) 
  };

  return (
    <div>
      <h2>Benefits</h2>
      <Button
        className="text-white btn-blue rounded float-right mb-3"
        onClick={() => setModalShow(true)}
      >
        Add Benefit
      </Button>

      <AddBenefit show={modalShow} onHide={modalClose} fetchProductBenefits={refetch} />
      <div className="mg-b-20">
        <div className="card-body pd-0 collapse show" id="customerDetails">
          <div className="table-responsive">
            <table className="table table-hover mg-0">
              <thead className="tx-dark tx-uppercase tx-12 tx-bold">
                <tr className="bg-light">
                  <th>Name</th>
                  <th>Description</th>
                  <th>Category</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {benefits?.data._value?.map((benefit) => (
                  <tr key={benefit.id}>
                    <td>{benefit.benefitName}</td>
                    <td>{benefit.benefitReference}</td>
                    <td>{benefit.benefitCategory}</td>
                    <td>{benefit.benefitCoverType}</td>
                    <td>
                      <Button onClick={() => handleEdit(benefit.id) } type="link" >View/Edit</Button>
                      <Button type="link" danger>
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Benefits;